import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'

const FILES_ROOT = '/files'
const YOUTUBE_TYPE = 'video/youtube'

/**
 * Realiza la carga de los archivos recibidos
 * @param {Array<File>} files arreglo con archivos a subir
 * @param {Array<File>} fileIds arreglo con IDs para los archivos
 */
export const bulkUploadFiles = async (files, fileIds) => {
    const formData = new FormData()

    files.forEach(async (file, index) => {
        // Se inicializa el objeto
        let formattedFile = file

        // Si el tipo del archivo es de youtube
        // Se necesita generar un Blob con los datos del video
        if (file.type === YOUTUBE_TYPE) {
            formattedFile = new Blob([JSON.stringify(file, null, 2)], {
                type: YOUTUBE_TYPE,
            })
        }

        formData.append('file', formattedFile)
        formData.append('fileId', fileIds[index])
    })

    return axios.post(REACT_APP_API + `${FILES_ROOT}/bulkCreate`, formData, {
        timeout: 240000,
    })
}
